import { ChecklistStatus } from './ChecklistStatus';
import { AventiObject } from './AventiObject';
import { UserTimestamp } from './User';
import { AventiFile } from './File';
import { Timestamp } from 'firebase/firestore';

export class Project {
  public no?: string;
  public name?: string;
  public nameshort?: string;
  public objecttypeversion?: string;
  public id?: string;
  public url?: string;
  public checklistStatus?: ChecklistStatus;
  public objects?: AventiObject[];
  public editedBy?: UserTimestamp[];
  public customerids?: string[];
  public mapurl?: string;
  public map?: {
    center: google.maps.LatLngLiteral;
    cabinets: {
      pos: google.maps.LatLngLiteral;
      name: string;
    }[];
    polyline: google.maps.Polyline;
  };
  public files?: AventiFile[];
  public fromCache?: boolean;
  public useStatusLevel?: boolean;
  public statusLevelUpdateInProgress?: STATUS_LEVEL_UPDATE_STATE;
  public statusLevelUpdateInProgressCount?: number;
  public statusLevelUpdateInProgressTotal?: number;
  public imagesZipFileUrl?: string;
  public imagesZipFileSizeB?: number;
  public imagesZipFileSizeString?: string;
  public imagesZipFileTimestamp?: Timestamp;
  public triggerUpdate?: Timestamp;
  public pdfExportImageMaxSizeKB?: number;
}

export enum STATUS_LEVEL_UPDATE_STATE {
  DISABLED = 'DISABLED',
  REQUESTED = 'REQUESTED',
  STARTED = 'STARTED',
  FINISHED = 'FINISHED',
}

export enum FILE_EXPORT_UPDATE_STATE {
  REQUESTED = 'REQUESTED',
  STARTED = 'STARTED',
  FINALIZING = 'FINALIZING',
  FINISHED = 'FINISHED',
  ERROR = 'ERROR',
}
